// Auto-generated feature flags from Azure App Configuration
// Generated at: 2026-09-11T09:52:25.540Z
// Do not edit this file manually
// Priority order: Custom Label > Global > No Label

export interface FeatureFlag {
  enabled: boolean;
  conditions: Record<string, any>;
  description: string;
  lastModified: string;
}

export interface FeatureFlags {
  readonly aIDesignCreator: FeatureFlag;
  readonly aIStudioInPreview: FeatureFlag;
  readonly aIEPSToSvg: FeatureFlag;
  readonly accessibilityWidget: FeatureFlag;
  readonly additionalAttributes: FeatureFlag;
  readonly aiStudio3D: FeatureFlag;
  readonly allowAIToolsForTrialUsers: FeatureFlag;
  readonly bOAIAgent: FeatureFlag;
  readonly backgroundRemoverLegacySelection: FeatureFlag;
  readonly bulkExport: FeatureFlag;
  readonly bulkImport: FeatureFlag;
  readonly bulkUnitPrice: FeatureFlag;
  readonly configuratorUrlSwitch: FeatureFlag;
  readonly convertToCurrencyForMasterIntegration: FeatureFlag;
  readonly discoveryMode: FeatureFlag;
  readonly filledText: FeatureFlag;
  readonly iNKSCAPEIMAGECONVERSIONUPLOAD: FeatureFlag;
  readonly interfacePlugins: FeatureFlag;
  readonly jsonProductsImport: FeatureFlag;
  readonly mOQ: FeatureFlag;
  readonly madoo: FeatureFlag;
  readonly newConfiguratorBackoffice: FeatureFlag;
  readonly newConfiguratorUIEnabled: FeatureFlag;
  readonly newCustomizerMonochromeUI: FeatureFlag;
  readonly orderErrors: FeatureFlag;
  readonly pDFTOSVG: FeatureFlag;
  readonly preview3DCamera: FeatureFlag;
  readonly proofing: FeatureFlag;
  readonly prototypeMode: FeatureFlag;
  readonly rateLimit: FeatureFlag;
  readonly sVGCROP: FeatureFlag;
  readonly salesChannelsOnBulk: FeatureFlag;
  readonly shopifyNewAuth: FeatureFlag;
  readonly shopifyRedactProducts: FeatureFlag;
  readonly standalone: FeatureFlag;
  readonly startWithAIAgent: FeatureFlag;
  readonly storageFeature: FeatureFlag;
  readonly svgClipEnabled: FeatureFlag;
  readonly svgConvertTextInOutlinesEnabled: FeatureFlag;
  readonly designwithaibackoffice: FeatureFlag;
  readonly minimumOrderQuantityPriceUi: FeatureFlag;
  readonly standaloneSitePlanOverride: FeatureFlag;
  readonly switchSalesChannel: FeatureFlag;
}

export const FEATURE_FLAGS: FeatureFlags = {
  aIDesignCreator: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-07-23T12:22:44.000Z"
  },
  aIStudioInPreview: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "291404",
                        "5724"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "Abilita AI Studio in Preview prodotto, per poter aprire prodotto in finestra di AI Studio per rapida creazione di immagini varie",
    lastModified: "2026-03-30T17:03:10.000Z"
  },
  aIEPSToSvg: {
    enabled: true,
    conditions: {},
    description: "",
    lastModified: "2025-11-25T11:49:13.000Z"
  },
  accessibilityWidget: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "Widget a11y",
    lastModified: "2025-10-30T10:06:54.000Z"
  },
  additionalAttributes: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-10-03T13:43:44.000Z"
  },
  aiStudio3D: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-31T10:36:54.000Z"
  },
  allowAIToolsForTrialUsers: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-25T13:17:45.000Z"
  },
  bOAIAgent: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-08-11T11:13:16.000Z"
  },
  backgroundRemoverLegacySelection: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-04-02T07:11:19.000Z"
  },
  bulkExport: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-08-18T14:26:26.000Z"
  },
  bulkImport: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-05-29T09:00:52.000Z"
  },
  bulkUnitPrice: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-07-02T06:58:21.000Z"
  },
  configuratorUrlSwitch: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "Se mostrare lo switch per cambiare tra nuovo/vecchio tema configuratore su nuovo BO",
    lastModified: "2026-06-01T14:01:25.000Z"
  },
  convertToCurrencyForMasterIntegration: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "24"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 50
                }
            }
        }
    ]
},
    description: "Used for convert order fee to the currency of the master integration",
    lastModified: "2025-11-03T15:28:13.000Z"
  },
  discoveryMode: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "Enable discovery mode for the customizer",
    lastModified: "2026-09-11T09:51:05.000Z"
  },
  filledText: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-07-30T11:03:44.000Z"
  },
  iNKSCAPEIMAGECONVERSIONUPLOAD: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-01-19T15:13:13.000Z"
  },
  interfacePlugins: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-12T11:47:38.000Z"
  },
  jsonProductsImport: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-10-06T10:27:53.000Z"
  },
  mOQ: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-09T10:36:45.000Z"
  },
  madoo: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-07-09T14:30:38.000Z"
  },
  newConfiguratorBackoffice: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "251296",
                        "250458",
                        "250507",
                        "5724",
                        "311399",
                        "311415",
                        "311414",
                        "251258"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "A feature flag for enabling the new configurator backoffice",
    lastModified: "2026-09-10T12:57:05.000Z"
  },
  newConfiguratorUIEnabled: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "5724",
                        "311399",
                        "251258"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "This flag will enable the new UI for configurator products",
    lastModified: "2026-08-27T15:57:21.000Z"
  },
  newCustomizerMonochromeUI: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [],
                    "Groups": [],
                    "DefaultRolloutPercentage": 100
                }
            }
        }
    ]
},
    description: "Abilita Monochrome UI per maxColors 1",
    lastModified: "2026-02-10T11:00:29.000Z"
  },
  orderErrors: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-10-04T15:27:05.000Z"
  },
  pDFTOSVG: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "24",
                        "251296"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2025-12-18T15:25:14.000Z"
  },
  preview3DCamera: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-02T11:30:17.000Z"
  },
  proofing: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-08-27T10:33:37.000Z"
  },
  prototypeMode: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "299791",
                        "2112"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-05-07T10:16:35.000Z"
  },
  rateLimit: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-02-09T09:25:50.000Z"
  },
  sVGCROP: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-08-11T13:33:34.000Z"
  },
  salesChannelsOnBulk: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-06-25T14:23:15.000Z"
  },
  shopifyNewAuth: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-09-01T10:57:59.000Z"
  },
  shopifyRedactProducts: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-07-01T13:48:08.000Z"
  },
  standalone: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-04T15:37:01.000Z"
  },
  startWithAIAgent: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "5913"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 100
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-08-11T11:15:39.000Z"
  },
  storageFeature: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "Is used to show the Storage section ",
    lastModified: "2025-06-23T14:59:29.000Z"
  },
  svgClipEnabled: {
    enabled: true,
    conditions: {},
    description: "",
    lastModified: "2025-11-24T12:35:52.000Z"
  },
  svgConvertTextInOutlinesEnabled: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-10T16:14:05.000Z"
  },
  designwithaibackoffice: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "291404",
                        "5724",
                        "311399"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "Design with AI disabilitato in BO merchant tranne per utenti specifici",
    lastModified: "2026-02-24T10:56:19.000Z"
  },
  minimumOrderQuantityPriceUi: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "5724",
                        "311405"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "Limitato a testing per demo di kickoff prima dell osviluppo effettivo",
    lastModified: "2026-03-04T12:30:23.000Z"
  },
  standaloneSitePlanOverride: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "5913",
                        "24"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "used to enable the Standalone feature even if it's not in the plan",
    lastModified: "2026-07-17T10:18:45.000Z"
  },
  switchSalesChannel: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "250893",
                        "5913",
                        "271314",
                        "291405",
                        "311429",
                        "311399",
                        "321471",
                        "321472"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "If you active this feature you can enable the possibility of switching of the sales channels",
    lastModified: "2026-07-02T08:13:05.000Z"
  }
} as const;

// Helper function to check if a feature is enabled
export function isFeatureEnabled(flagName: keyof FeatureFlags): boolean {
  return FEATURE_FLAGS[flagName]?.enabled ?? false;
}

// Helper function to get feature flag conditions
export function getFeatureConditions(flagName: keyof FeatureFlags): Record<string, any> {
  return FEATURE_FLAGS[flagName]?.conditions ?? {};
}

// Helper function to check feature with custom conditions
export function isFeatureEnabledWithConditions(
  flagName: keyof FeatureFlags, 
  userContext?: Record<string, any>
): boolean {
  const flag = FEATURE_FLAGS[flagName];
  if (!flag) return false;
  
  if (!flag.enabled) return false;
  
	// If no conditions or user context, return base enabled state
	const hasNoConditions = !flag.conditions || Object.keys(flag.conditions).length === 0;
	const hasEmptyClientFilters =
		flag.conditions?.client_filters && (!Array.isArray(flag.conditions.client_filters) || flag.conditions.client_filters.length === 0);
	const noUserContext = !userContext;

	if (hasNoConditions || hasEmptyClientFilters || noUserContext) {
		return flag.enabled;
	}

    // Handle Azure App Configuration client_filters format
  if (flag.conditions.client_filters && Array.isArray(flag.conditions.client_filters)) {
    for (const filter of flag.conditions.client_filters) {
      // Handle old UserID format
      if (filter.name === 'UserID' && filter.parameters && filter.parameters.userID) {
        const requiredUserId = filter.parameters.userID;
        const userIdFromContext = userContext.userId ? parseInt(userContext.userId) : undefined;
        
        if (userIdFromContext === requiredUserId) {
          return true;
        }
      }
        // Handle new Microsoft.Targeting format
      if (filter.name === 'Microsoft.Targeting' && filter.parameters && filter.parameters.Audience) {
        const audience = filter.parameters.Audience;
        const userIdFromContext = userContext.userId ? userContext.userId.toString() : undefined;
        
        // Check if user is in the Users array
        if (audience.Users && Array.isArray(audience.Users) && userIdFromContext) {
          if (audience.Users.includes(userIdFromContext)) {
            return true;
          }
        }
        
        // TODO: Handle Groups and DefaultRolloutPercentage if needed
      }
        // Handle Env (Environment) filter
      if (filter.name === 'Env' && filter.parameters && filter.parameters.env) {
        const requiredEnv = filter.parameters.env;
        // Check environment from userContext.environment, userContext.env, or NODE_ENV
        const currentEnv = userContext.environment || userContext.env || process.env.NODE_ENV;
        
        if (currentEnv === requiredEnv) {
          return true;
        }
      }
    }
    // If we have client_filters but none matched, return false
    return false;
  }
  
  // Fallback to simple condition evaluation for other formats
  for (const [conditionKey, conditionValue] of Object.entries(flag.conditions)) {
    if (userContext[conditionKey] !== conditionValue) {
      return false;
    }
  }
  
  return true;
}

// Export individual feature flags for direct access
export const AIDESIGN_CREATOR_FEATURE = FEATURE_FLAGS.aIDesignCreator;
export const AISTUDIO_IN_PREVIEW_FEATURE = FEATURE_FLAGS.aIStudioInPreview;
export const AI_EPS_TO_SVG_FEATURE = FEATURE_FLAGS.aIEPSToSvg;
export const ACCESSIBILITY_WIDGET_FEATURE = FEATURE_FLAGS.accessibilityWidget;
export const ADDITIONAL_ATTRIBUTES_FEATURE = FEATURE_FLAGS.additionalAttributes;
export const AI_STUDIO3D_FEATURE = FEATURE_FLAGS.aiStudio3D;
export const ALLOW_AITOOLS_FOR_TRIAL_USERS_FEATURE = FEATURE_FLAGS.allowAIToolsForTrialUsers;
export const BOAIAGENT_FEATURE = FEATURE_FLAGS.bOAIAgent;
export const BACKGROUND_REMOVER_LEGACY_SELECTION_FEATURE = FEATURE_FLAGS.backgroundRemoverLegacySelection;
export const BULK_EXPORT_FEATURE = FEATURE_FLAGS.bulkExport;
export const BULK_IMPORT_FEATURE = FEATURE_FLAGS.bulkImport;
export const BULK_UNIT_PRICE_FEATURE = FEATURE_FLAGS.bulkUnitPrice;
export const CONFIGURATOR_URL_SWITCH_FEATURE = FEATURE_FLAGS.configuratorUrlSwitch;
export const CONVERT_TO_CURRENCY_FOR_MASTER_INTEGRATION_FEATURE = FEATURE_FLAGS.convertToCurrencyForMasterIntegration;
export const DISCOVERY_MODE_FEATURE = FEATURE_FLAGS.discoveryMode;
export const FILLED_TEXT_FEATURE = FEATURE_FLAGS.filledText;
export const INKSCAPE_IMAGE_CONVERSION_UPLOAD_FEATURE = FEATURE_FLAGS.iNKSCAPEIMAGECONVERSIONUPLOAD;
export const INTERFACE_PLUGINS_FEATURE = FEATURE_FLAGS.interfacePlugins;
export const JSON_PRODUCTS_IMPORT_FEATURE = FEATURE_FLAGS.jsonProductsImport;
export const MOQ_FEATURE = FEATURE_FLAGS.mOQ;
export const MADOO_FEATURE = FEATURE_FLAGS.madoo;
export const NEW_CONFIGURATOR_BACKOFFICE_FEATURE = FEATURE_FLAGS.newConfiguratorBackoffice;
export const NEW_CONFIGURATOR_UIENABLED_FEATURE = FEATURE_FLAGS.newConfiguratorUIEnabled;
export const NEW_CUSTOMIZER_MONOCHROME_UI_FEATURE = FEATURE_FLAGS.newCustomizerMonochromeUI;
export const ORDER_ERRORS_FEATURE = FEATURE_FLAGS.orderErrors;
export const PDF_TO_SVG_FEATURE = FEATURE_FLAGS.pDFTOSVG;
export const PREVIEW3DCAMERA_FEATURE = FEATURE_FLAGS.preview3DCamera;
export const PROOFING_FEATURE = FEATURE_FLAGS.proofing;
export const PROTOTYPE_MODE_FEATURE = FEATURE_FLAGS.prototypeMode;
export const RATE_LIMIT_FEATURE = FEATURE_FLAGS.rateLimit;
export const SVG_CROP_FEATURE = FEATURE_FLAGS.sVGCROP;
export const SALES_CHANNELS_ON_BULK_FEATURE = FEATURE_FLAGS.salesChannelsOnBulk;
export const SHOPIFY_NEW_AUTH_FEATURE = FEATURE_FLAGS.shopifyNewAuth;
export const SHOPIFY_REDACT_PRODUCTS_FEATURE = FEATURE_FLAGS.shopifyRedactProducts;
export const STANDALONE_FEATURE = FEATURE_FLAGS.standalone;
export const START_WITH_AIAGENT_FEATURE = FEATURE_FLAGS.startWithAIAgent;
export const STORAGE_FEATURE_FEATURE = FEATURE_FLAGS.storageFeature;
export const SVG_CLIP_ENABLED_FEATURE = FEATURE_FLAGS.svgClipEnabled;
export const SVG_CONVERT_TEXT_IN_OUTLINES_ENABLED_FEATURE = FEATURE_FLAGS.svgConvertTextInOutlinesEnabled;
export const DESIGNWITHAIBACKOFFICE_FEATURE = FEATURE_FLAGS.designwithaibackoffice;
export const MINIMUM_ORDER_QUANTITY_PRICE_UI_FEATURE = FEATURE_FLAGS.minimumOrderQuantityPriceUi;
export const STANDALONE_SITE_PLAN_OVERRIDE_FEATURE = FEATURE_FLAGS.standaloneSitePlanOverride;
export const SWITCH_SALES_CHANNEL_FEATURE = FEATURE_FLAGS.switchSalesChannel;

// Feature flag names enum
export enum FeatureFlagNames {
  AIDESIGN_CREATOR = 'aIDesignCreator',
  AISTUDIO_IN_PREVIEW = 'aIStudioInPreview',
  AI_EPS_TO_SVG = 'aIEPSToSvg',
  ACCESSIBILITY_WIDGET = 'accessibilityWidget',
  ADDITIONAL_ATTRIBUTES = 'additionalAttributes',
  AI_STUDIO3D = 'aiStudio3D',
  ALLOW_AITOOLS_FOR_TRIAL_USERS = 'allowAIToolsForTrialUsers',
  BOAIAGENT = 'bOAIAgent',
  BACKGROUND_REMOVER_LEGACY_SELECTION = 'backgroundRemoverLegacySelection',
  BULK_EXPORT = 'bulkExport',
  BULK_IMPORT = 'bulkImport',
  BULK_UNIT_PRICE = 'bulkUnitPrice',
  CONFIGURATOR_URL_SWITCH = 'configuratorUrlSwitch',
  CONVERT_TO_CURRENCY_FOR_MASTER_INTEGRATION = 'convertToCurrencyForMasterIntegration',
  DISCOVERY_MODE = 'discoveryMode',
  FILLED_TEXT = 'filledText',
  INKSCAPE_IMAGE_CONVERSION_UPLOAD = 'iNKSCAPEIMAGECONVERSIONUPLOAD',
  INTERFACE_PLUGINS = 'interfacePlugins',
  JSON_PRODUCTS_IMPORT = 'jsonProductsImport',
  MOQ = 'mOQ',
  MADOO = 'madoo',
  NEW_CONFIGURATOR_BACKOFFICE = 'newConfiguratorBackoffice',
  NEW_CONFIGURATOR_UIENABLED = 'newConfiguratorUIEnabled',
  NEW_CUSTOMIZER_MONOCHROME_UI = 'newCustomizerMonochromeUI',
  ORDER_ERRORS = 'orderErrors',
  PDF_TO_SVG = 'pDFTOSVG',
  PREVIEW3DCAMERA = 'preview3DCamera',
  PROOFING = 'proofing',
  PROTOTYPE_MODE = 'prototypeMode',
  RATE_LIMIT = 'rateLimit',
  SVG_CROP = 'sVGCROP',
  SALES_CHANNELS_ON_BULK = 'salesChannelsOnBulk',
  SHOPIFY_NEW_AUTH = 'shopifyNewAuth',
  SHOPIFY_REDACT_PRODUCTS = 'shopifyRedactProducts',
  STANDALONE = 'standalone',
  START_WITH_AIAGENT = 'startWithAIAgent',
  STORAGE_FEATURE = 'storageFeature',
  SVG_CLIP_ENABLED = 'svgClipEnabled',
  SVG_CONVERT_TEXT_IN_OUTLINES_ENABLED = 'svgConvertTextInOutlinesEnabled',
  DESIGNWITHAIBACKOFFICE = 'designwithaibackoffice',
  MINIMUM_ORDER_QUANTITY_PRICE_UI = 'minimumOrderQuantityPriceUi',
  STANDALONE_SITE_PLAN_OVERRIDE = 'standaloneSitePlanOverride',
  SWITCH_SALES_CHANNEL = 'switchSalesChannel'
}

// Build-time feature flags metadata
export const FEATURE_FLAGS_METADATA = {
  generatedAt: '2026-09-11T09:52:25.540Z',
  totalFlags: 43,
  enabledFlags: 42,
  flagNames: ['AIDesignCreator', 'AIStudioInPreview', 'AI_EPS_ToSvg', 'AccessibilityWidget', 'AdditionalAttributes', 'AiStudio3D', 'AllowAIToolsForTrialUsers', 'BOAIAgent', 'BackgroundRemoverLegacySelection', 'BulkExport', 'BulkImport', 'BulkUnitPrice', 'ConfiguratorUrlSwitch', 'ConvertToCurrencyForMasterIntegration', 'DiscoveryMode', 'FilledText', 'INKSCAPE_IMAGE_CONVERSION_UPLOAD', 'InterfacePlugins', 'JsonProductsImport', 'MOQ', 'Madoo', 'NewConfiguratorBackoffice', 'NewConfiguratorUIEnabled', 'NewCustomizerMonochromeUI', 'OrderErrors', 'PDF_TO_SVG', 'Preview3DCamera', 'Proofing', 'PrototypeMode', 'RateLimit', 'SVG_CROP', 'SalesChannelsOnBulk', 'ShopifyNewAuth', 'ShopifyRedactProducts', 'Standalone', 'StartWithAIAgent', 'StorageFeature', 'SvgClipEnabled', 'SvgConvertTextInOutlinesEnabled', 'designwithaibackoffice', 'minimumOrderQuantityPriceUi', 'standaloneSitePlanOverride', 'switchSalesChannel'] as const
} as const;
